module.exports = __webpack_public_path__ + "img/crm2_2.90f568a4.png";